import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItemName } from '../../../../lib/models/Form';
import { FormItem } from '../../../../components/FormItem';
import { FormInput } from '../../../../components/FormInput';

const label = 'pages.products.productCategories.formItems.description.label';

export const DescriptionFormItem: FC = () => {
  const { t } = useTranslation();

  return (
    <FormItem name={FormItemName.DESCRIPTION} hasFeedback rules={[{ max: 100 }]}>
      <FormInput label={t(label)} />
    </FormItem>
  );
};
